export const CRITICAL_ERRORS = {
	DEM109: 'Algunos de los datos ingresados son inválidos. Por favor, verifica los campos e inténtalo nuevamente'
}

export const isCriticalError = (errorCode) => errorCode && CRITICAL_ERRORS[errorCode]
